import {
  getNewGenreProfileInsights,
  getGenreProfileImgDataMobile,
  getGenreProfileDetailCrTen,
} from '@/pages/intelligence/services/genreProfile';

export function translateStateParams(base: any) {
  if (base.entity_type != 'mobile') {
    return base;
  }
  const requestParams: any = {
    regions: (() => {
      if (base.data_tag == 'countries' && base.regions.length == 1 && base.regions[0] == 'global') {
        return [];
      }
      return [...base.regions];
    })(),
    entity_type: base.entity_type, // "mobile",
    regionType: 'market',
    genre_tab: base.genre_tab,
    genreSegment: 'all',
    dataSourceSingle: base.dataSourceSingle,
    genre_source: base.genre_source, // "iegg",
    granularity: base.granularity, // "monthly",
    start_date: base.start_date, // "",
    end_date: base.end_date, // "",
    iegg_genre_req: [],
    genre: [],
    source_metrics: (() => {
      // 这里要使用筛选器的值，可以从外部传进来
      const metrics: any = {};
      // todo: @yao 这里需要根据筛选器的值来判断
      // 如果有sensortower

      metrics[`${base.dataSourceSingle}`] = [];
      return metrics;
    })(),
    genre_rank: [
      {
        [`${base.genre_tab}_genre`]: base.genre, // 主
        source: base.genre_source,
      },
    ],
    page: base.page,
    page_size: base.page_size,
  };

  return requestParams;
}

export function translateStateListFunc(base: any) {
  if (base.entity_type != 'mobile') {
    return getGenreProfileDetailCrTen;
  }
  return getNewGenreProfileInsights;
}

export async function translateStateResponse(base: any, req: any, result: any) {
  if (base.entity_type != 'mobile') {
    return result;
  }
  const data = result?.data || {};
  // 忘了转小写了，兼容一下
  const trends = data.MarketCR10RevTrend || data.market_cr10_rev_trend || [];
  const games = data.MarketCR10Games || data.market_cr10_games || [];
  const game_ids = games.map((e: any) => e.id);
  const gameRet = await getGenreProfileImgDataMobile({
    ids: game_ids,
    entity_type: base.entity_type,
    level: 'full',
  });
  // 请求游戏详情
  const finalData = {
    req,
    data: {
      market_cr_10_games: games.map((e: any) => {
        const gameInfo = gameRet?.data?.[e.id] || {};
        return {
          id: e.id,
          value: e.daily_revenue,
          dod: e.daily_revenue_percentage,
          name: gameInfo.entity_name,
          cover: gameInfo.cover,
          // todo: @yao 这个publisher似乎不对，对一下原来的数据
          publisher: gameInfo.publisher,
          metric: 'revenue',
          source: (() => {
            if (gameInfo?.source == 'appannie') {
              return 'appannie';
            }
            return 'sensortower';
          })(),
        };
      }),
      market_cr_10_rev_trend: trends.map((e: any) => {
        return {
          date: e.date, // "2024-05-03",
          cr10_rev: e.top_10_revenue, // 12017374,
          dod: e.top_10_revenue_percentage, // .0.6404159541903414
        };
      }),
      start_date: result?.req?.start_date,
      end_date: result?.req?.end_date,
    },
  };
  return finalData;
}
